@if (container()) {
  <rt-interview-base-box
    [question]="question"
    [invalid]="parentForm.get('rating')!.invalid && parentForm.get('rating')!.touched"
  >
    <ng-template
      [ngTemplateOutlet]="formTemplate"
      [ngTemplateOutletContext]="{ noteOpen: state.noteOpen, parentForm: parentForm }"
    />
  </rt-interview-base-box>
}

@if (!container()) {
  <ng-template
    [ngTemplateOutlet]="formTemplate"
    [ngTemplateOutletContext]="{ noteOpen: state.noteOpen, parentForm: parentForm }"
  />
}

<ng-template #formTemplate>
  <div
    [formGroup]="parentForm"
    [class.short]="short()"
    [attr.padding-lr]="short() || null"
    [attr.padding-top]="short() || null"
  >
    @if (assignedPlacement) {
      <div margin-bottom-small layout layout-vertical>
        <rt-heading variant="uppercased block" margin-bottom-small>
          <span class="text-wrap" layout layout-align-items-center>
            {{ 'app.interview.summary.assigned_to' | translate }}
          </span>
        </rt-heading>
        <rt-offer-info-box [info]="assignedPlacement" layout-full-width />
      </div>
    }
    @if (offers && offers.length > 1) {
      <div margin-bottom-small>
        <rt-heading variant="uppercased block" margin-bottom-small>
          <span class="text-wrap" layout layout-align-items-center>
            {{ 'app.interview.summary.assign_to' | translate }}
          </span>
        </rt-heading>
        <rt-offer-select
          [formControl]="$any(parentForm.get('offerId'))"
          [offers]="offers"
          [hasSearch]="false"
          [hasInputTrigger]="true"
          [includeEmptyOption]="false"
        />
      </div>
    }

    @if (useRedactor()) {
      <rt-heading variant="uppercased block" margin-bottom-small>
        <span class="text-wrap" layout layout-align-items-center>
          {{ 'app.interview.summary.note' | translate }}
          <rt-badge
            color="secondary"
            [text]="'app.common.optional' | translate"
            margin-left-small-xx
          />
        </span>
      </rt-heading>
      <!-- Security: This value is briefly sanitized by Recruitee/api -->
      <rt-redactor
        [config]="redactorConfig"
        [autoFocus]="redactorAutofocus()"
        [rtProtectedControl]="parentForm.get('ratingNote')"
        [rtProtectedControlName]="'app.interview.summary.note' | translate"
        [rtProtectedControlEnabled]="hasProtectedControls()"
        formControlName="ratingNote"
        margin-top-small
      />
    }

    @if (!useRedactor()) {
      <rt-textarea
        [rtProtectedControl]="parentForm.get('ratingNote')"
        [rtProtectedControlName]="'app.interview.summary.note' | translate"
        [rtProtectedControlEnabled]="hasProtectedControls()"
        formControlName="ratingNote"
        margin-top-small
      />
    }

    <rt-heading variant="uppercased block" margin-bottom-small margin-top-small>
      <span class="text-wrap">
        {{ 'app.interview.evaluation_score' | translate }}
        @if (showRequiredLabel()) {
          <span class="badge-required"> * </span>
        }
      </span>
      @if (showSelectedValue() && parentForm.get('rating')!.value !== '') {
        <span class="current-rating"
          >&nbsp;-&nbsp;{{ ratingMap[parentForm.get('rating')!.value] }}</span
        >
      }
    </rt-heading>

    <rt-interview-button-select
      [horizontal]="false"
      [short]="short()"
      [attr.layout-full-width]="short() || null"
      [attr.margin-bottom]="short() || null"
      [rtProtectedControl]="parentForm.get('rating')"
      [rtProtectedControlName]="'app.interview.summary.your_rate' | translate"
      [rtProtectedControlEnabled]="hasProtectedControls()"
      (rateButtonClick)="rateChange.emit()"
      formControlName="rating"
      layout-inline
    />
  </div>
</ng-template>
